module.exports = __webpack_public_path__ + "static/img/robot3.0c1891e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/robot3.png
// module id = ztg+
// module chunks = 0